import { render, staticRenderFns } from "./FilesMessages.vue?vue&type=template&id=cbf30b44&scoped=true"
import script from "./FilesMessages.vue?vue&type=script&lang=js"
export * from "./FilesMessages.vue?vue&type=script&lang=js"
import style0 from "./FilesMessages.vue?vue&type=style&index=0&id=cbf30b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf30b44",
  null
  
)

export default component.exports